export interface IOpenedPrintOptionsAccordions {
    consistencyChecksAccordion: boolean;
    componentsAccordion: boolean;
    settingsAccordion: boolean;
    signatureAccordion: boolean;
    colorsAccordion: boolean;
    fxAccordion?: boolean;
}
